<template>
  <div>
    <PageLoader :storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" :color="snackColor" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #fff">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex xs12>
        <v-layout wrap justify-start pa-4>
          <v-flex xs12 class="d-flex align-center justify-space-between pb-2">
            <span class="heading">District Medical Officer List</span>
            <v-btn color="#427D2D" small depressed @click="openAddDialog()">
              <v-icon small color="white" class="mr-1">mdi-plus</v-icon>
              <span style="font-size: 12px; font-family: poppinssemibold; color: white;">
                Add DMO
              </span>
            </v-btn>
          </v-flex>

          <v-flex xs12 pt-2>
            <v-layout wrap justify-start>
              <v-flex xs12 sm5 md4 lg3>
                <span class="tableitems">Search</span>
                <v-text-field
                  outlined
                  clearable
                  hide-details
                  dense
                  placeholder="Search by Name, Username or Phone"
                  class="text-des"
                  v-model="keyword"
                  style="font-family: sofiaProRegular;"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm5 md4 lg3 pl-sm-3 pl-md-3 pl-lg-3 pt-2 pt-sm-0>
                <span class="tableitems">District</span>
                <v-select
                  outlined
                  clearable
                  hide-details
                  dense
                  placeholder="Select District"
                  class="text-des"
                  :items="districts"
                  v-model="selectedDistrict"
                  style="font-family: sofiaProRegular;"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 py-4 v-if="userlist && userlist.length > 0">
            <v-layout wrap justify-start pt-2>
              <v-flex xs12>
                <v-card>
                  <div style="overflow-y: auto;">
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left tablehead">Name</th>
                            <th class="text-left tablehead">User Name</th>
                            <th class="text-left tablehead">Phone</th>
                            <th class="text-left tablehead">Email</th>
                            <th class="text-left tablehead">District</th>
                            <th class="text-left tablehead" v-if="mainRole === 'admin'">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in userlist" :key="index">
                            <td style="white-space: nowrap;" class="tableitems">{{ item.name }}</td>
                            <td style="white-space: nowrap;" class="tableitems">{{ item.username }}</td>
                            <td style="white-space: nowrap;" class="tableitems">{{ item.phone }}</td>
                            <td style="white-space: nowrap;" class="tableitems">{{ item.email || '-' }}</td>
                            <td style="white-space: nowrap;" class="tableitems">{{ item.district }}</td>
                            <td style="white-space: nowrap;" v-if="mainRole === 'admin'">
                              <v-icon
                                small
                                color="primary"
                                class="mr-1"
                                @click.stop="openEditDialog(item)"
                                title="Edit DMO"
                              >mdi-pencil</v-icon>
                              <v-icon
                                small
                                color="error"
                                class="ml-1"
                                @click.stop="rejectDialog(item._id)"
                                title="Delete DMO"
                              >mdi-delete</v-icon>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </div>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 v-else pt-10>
            <v-layout wrap justify-center align-center>
              <v-flex xs12 class="text-center">
                <span class="nodata">No District Medical Officers Found!</span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex xs12 pb-4 v-if="userlist && userlist.length > 0">
        <v-layout wrap justify-center>
          <v-flex xs10>
            <v-pagination
              v-model="currentPage"
              :total-visible="7"
              :length="Pagelength"
              circle
              color="#427D2D"
              small
            ></v-pagination>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- ADD DMO DIALOG -->
    <v-dialog v-model="adddialog" max-width="800px" persistent>
      <v-card rounded="lg">
        <v-card-title>
          <span class="heading">ADD DISTRICT MEDICAL OFFICER (DMO)</span>
          <v-spacer></v-spacer>
          <v-btn color="red" icon @click="adddialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-form>
            <v-layout wrap justify-start pt-2>
              <v-flex xs12 sm12 md6 lg6 pr-md-2 class="subheading">
                <span style="color:black">User Name</span>
                <v-text-field class="pt-2 text-des" outlined v-model="username" dense hide-details></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6 lg6 class="subheading">
                <span style="color:black">Full Name</span>
                <v-text-field class="pt-2 text-des" outlined v-model="name" dense hide-details></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6 lg6 pt-2 pr-md-2 class="subheading">
                <span style="color:black">Phone Number</span>
                <v-text-field class="pt-2 text-des" outlined v-model="phone" dense hide-details type="number"></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6 lg6 pt-2 class="subheading">
                <span style="color:black">Email</span>
                <v-text-field class="pt-2 text-des" outlined v-model="email" dense hide-details></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md12 lg12 pt-2 class="subheading">
                <span style="color:black">Select District</span>
                <v-select
                  outlined
                  hide-details
                  dense
                  :items="formDistricts"
                  class="pt-2 text-des"
                  v-model="districtForm"
                  placeholder="Select District"
                  style="font-family: sofiaProRegular;"
                ></v-select>
              </v-flex>

              <v-flex xs12 sm12 md6 lg6 pt-2 pr-md-2 class="subheading">
                <span style="color:black">Password</span>
                <v-text-field
                  class="pt-2 text-des"
                  outlined
                  v-model="password"
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword"
                  dense
                  hide-details
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6 lg6 pt-2 class="subheading">
                <span style="color:black">Confirm Password</span>
                <v-text-field
                  class="pt-2 text-des"
                  outlined
                  v-model="cpassword"
                  :type="showConfirmPassword ? 'text' : 'password'"
                  :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showConfirmPassword = !showConfirmPassword"
                  dense
                  hide-details
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>

        <v-card-actions class="py-4 justify-end headline lighten-2">
          <v-btn tile outlined color="#FF1313" text @click="adddialog = false">
            <span style="color: black;">Cancel</span>
          </v-btn>
          <v-btn tile color="#427D2D" depressed @click="itemadd()">
            <span style="color:white;">Submit</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- EDIT DMO DIALOG -->
    <v-dialog v-model="editdialog" max-width="800px" persistent>
      <v-card rounded="lg">
        <v-card-title>
          <span class="heading">EDIT DISTRICT MEDICAL OFFICER (DMO)</span>
          <v-spacer></v-spacer>
          <v-btn color="red" icon @click="editdialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-form>
            <v-layout wrap justify-start pt-2>
              <v-flex xs12 sm12 md6 lg6 pr-md-2 class="subheading">
                <span style="color:black">User Name</span>
                <v-text-field class="pt-2 text-des" outlined v-model="editUsername" dense disabled hide-details></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6 lg6 class="subheading">
                <span style="color:black">Full Name</span>
                <v-text-field class="pt-2 text-des" outlined v-model="editName" dense hide-details></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6 lg6 pt-2 pr-md-2 class="subheading">
                <span style="color:black">Phone Number</span>
                <v-text-field class="pt-2 text-des" outlined v-model="editPhone" dense hide-details type="number"></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6 lg6 pt-2 class="subheading">
                <span style="color:black">Email</span>
                <v-text-field class="pt-2 text-des" outlined v-model="editEmail" dense hide-details></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md12 lg12 pt-2 class="subheading">
                <span style="color:black">Select District</span>
                <v-select
                  outlined
                  hide-details
                  dense
                  :items="formDistricts"
                  class="pt-2 text-des"
                  v-model="editDistrict"
                  placeholder="Select District"
                  style="font-family: sofiaProRegular;"
                ></v-select>
              </v-flex>

              <v-flex xs12 sm12 md12 lg12 pt-2 class="subheading">
                <span style="color:black">New Password (Leave blank to keep current)</span>
                <v-text-field
                  class="pt-2 text-des"
                  outlined
                  v-model="editPassword"
                  :type="showEditPassword ? 'text' : 'password'"
                  :append-icon="showEditPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showEditPassword = !showEditPassword"
                  dense
                  hide-details
                  placeholder="Enter new password if changing"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>

        <v-card-actions class="py-4 justify-end headline lighten-2">
          <v-btn tile outlined color="#FF1313" text @click="editdialog = false">
            <span style="color: black;">Cancel</span>
          </v-btn>
          <v-btn tile color="#427D2D" depressed @click="itemEdit()">
            <span style="color:white;">Save Changes</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DELETE DIALOG -->
    <v-dialog v-model="deleteDialog" max-width="500">
      <v-card>
        <v-card-title class="heading">Delete District Medical Officer</v-card-title>
        <v-card-text>
          Are you sure you want to delete this District Medical Officer?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn tile outlined color="#FF1313" @click="deleteDialog = false" class="itemValue">
            Cancel
          </v-btn>
          <v-btn tile color="#427D2D" depressed @click="deleteUser()" class="itemValue">
            <span style="color: #fff">Confirm</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "AllDmoList",
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      snackColor: "#427D2D",
      timeout: 5000,
      msg: null,
      count: 20,
      keyword: "",
      selectedDistrict: "",
      
      // Add Form
      name: "",
      username: "",
      password: "",
      cpassword: "",
      phone: "",
      email: "",
      districtForm: "",
      showPassword: false,
      showConfirmPassword: false,
      adddialog: false,

      // Edit Form
      editId: null,
      editUsername: "",
      editName: "",
      editPhone: "",
      editEmail: "",
      editDistrict: "",
      editPassword: "",
      showEditPassword: false,
      editdialog: false,

      // Delete Dialog
      deleteDialog: false,
      deleteid: null,

      currentPage: 1,
      Pagelength: 1,
      userlist: [],
      districts: [
        "All",
        "Angul",
        "Boudh",
        "Balangir",
        "Bargarh",
        "Balasore",
        "Bhadrak",
        "Cuttack",
        "Deogarh",
        "Dhenkanal",
        "Ganjam",
        "Gajapati",
        "Jharsuguda",
        "Jajpur",
        "Jagatsinghapur",
        "Khordha",
        "Keonjhar",
        "Kalahandi",
        "Kandhamal",
        "Koraput",
        "Kendrapara",
        "Malkangiri",
        "Mayurbhanj",
        "Nabarangpur",
        "Nuapada",
        "Nayagarh",
        "Puri",
        "Rayagada",
        "Sambalpur",
        "Subarnapur",
        "Sundargarh"
      ]
    };
  },
  computed: {
    mainRole() {
      return this.$store.state.userRole || "admin";
    },
    formDistricts() {
      return this.districts.filter((d) => d !== "All");
    }
  },
  beforeMount() {
    this.getData();
  },
  watch: {
    currentPage() {
      this.getData();
    },
    keyword() {
      this.currentPage = 1;
      this.getData();
    },
    selectedDistrict() {
      this.currentPage = 1;
      this.getData();
    }
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/dmo/list",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        params: {
          count: this.count,
          page: this.currentPage,
          keyword: this.keyword,
          district: this.selectedDistrict
        }
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.userlist = response.data.data;
            this.Pagelength = response.data.pages || 1;
          } else {
            this.msg = response.data.msg;
            this.snackColor = "#D32F2F";
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    openAddDialog() {
      this.username = "";
      this.name = "";
      this.phone = "";
      this.email = "";
      this.districtForm = "";
      this.password = "";
      this.cpassword = "";
      this.showPassword = false;
      this.showConfirmPassword = false;
      this.adddialog = true;
    },
    openEditDialog(item) {
      this.editId = item._id;
      this.editUsername = item.username || "";
      this.editName = item.name || "";
      this.editPhone = item.phone || "";
      this.editEmail = item.email || "";
      this.editDistrict = item.district || "";
      this.editPassword = "";
      this.showEditPassword = false;
      this.editdialog = true;
    },
    rejectDialog(id) {
      this.deleteid = id;
      this.deleteDialog = true;
    },
    deleteUser() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/dmo/delete",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        data: {
          id: this.deleteid
        }
      })
        .then((response) => {
          this.appLoading = false;
          this.deleteDialog = false;
          if (response.data.status) {
            this.msg = response.data.msg;
            this.snackColor = "#427D2D";
            this.showSnackBar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.snackColor = "#D32F2F";
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.deleteDialog = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    itemadd() {
      const phoneRegex = /^[0-9]{10}$/;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!this.username) {
        this.msg = "Please Provide User Name.";
        this.snackColor = "#D32F2F";
        this.showSnackBar = true;
        return;
      }
      if (!this.name) {
        this.msg = "Please Provide Full Name.";
        this.snackColor = "#D32F2F";
        this.showSnackBar = true;
        return;
      }
      if (!this.phone) {
        this.msg = "Please Provide Phone Number.";
        this.snackColor = "#D32F2F";
        this.showSnackBar = true;
        return;
      }
      if (!phoneRegex.test(this.phone)) {
        this.msg = "Please Provide a Valid 10-digit Phone Number.";
        this.snackColor = "#D32F2F";
        this.showSnackBar = true;
        return;
      }
      if (this.email && !emailRegex.test(this.email)) {
        this.msg = "Please Provide a Valid Email Address.";
        this.snackColor = "#D32F2F";
        this.showSnackBar = true;
        return;
      }
      if (!this.districtForm) {
        this.msg = "Please Select a District.";
        this.snackColor = "#D32F2F";
        this.showSnackBar = true;
        return;
      }
      if (!this.password) {
        this.msg = "Please Provide Password.";
        this.snackColor = "#D32F2F";
        this.showSnackBar = true;
        return;
      }
      if (!this.cpassword) {
        this.msg = "Please Confirm Password.";
        this.snackColor = "#D32F2F";
        this.showSnackBar = true;
        return;
      }
      if (this.password !== this.cpassword) {
        this.msg = "Password and Confirm Password must match.";
        this.snackColor = "#D32F2F";
        this.showSnackBar = true;
        return;
      }

      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/dmo/register",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        data: {
          username: this.username,
          name: this.name,
          password: this.password,
          cpassword: this.cpassword,
          phone: this.phone,
          email: this.email,
          district: this.districtForm
        }
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = response.data.msg;
            this.snackColor = "#427D2D";
            this.showSnackBar = true;
            this.adddialog = false;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.snackColor = "#D32F2F";
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    itemEdit() {
      const phoneRegex = /^[0-9]{10}$/;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!this.editName) {
        this.msg = "Please Provide Full Name.";
        this.snackColor = "#D32F2F";
        this.showSnackBar = true;
        return;
      }
      if (!this.editPhone) {
        this.msg = "Please Provide Phone Number.";
        this.snackColor = "#D32F2F";
        this.showSnackBar = true;
        return;
      }
      if (!phoneRegex.test(this.editPhone)) {
        this.msg = "Please Provide a Valid 10-digit Phone Number.";
        this.snackColor = "#D32F2F";
        this.showSnackBar = true;
        return;
      }
      if (this.editEmail && !emailRegex.test(this.editEmail)) {
        this.msg = "Please Provide a Valid Email Address.";
        this.snackColor = "#D32F2F";
        this.showSnackBar = true;
        return;
      }
      if (!this.editDistrict) {
        this.msg = "Please Select a District.";
        this.snackColor = "#D32F2F";
        this.showSnackBar = true;
        return;
      }

      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/dmo/edit",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        data: {
          id: this.editId,
          name: this.editName,
          phone: this.editPhone,
          email: this.editEmail,
          district: this.editDistrict,
          password: this.editPassword
        }
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = response.data.msg;
            this.snackColor = "#427D2D";
            this.showSnackBar = true;
            this.editdialog = false;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.snackColor = "#D32F2F";
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    }
  }
};
</script>

<style scoped>
.heading {
  font-family: poppinssemibold;
  font-size: 20px;
  font-weight: 600;
}
.subheading {
  font-family: sofiaProRegular;
  font-size: 14px;
}
.tablehead {
  font-family: poppinssemibold;
  font-size: 13px;
  color: #000;
}
.tableitems {
  font-family: sofiaProRegular;
  font-size: 13px;
}
.nodata {
  font-family: poppinsregular;
  font-size: 16px;
  color: #777;
}
</style>